import { b as _extends, d as _inheritsLoose } from './chunk-fb907809.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { theme } from 'styled-tools';
import hoistNonReactStatics from 'hoist-non-react-statics';
import styled from './styled.js';
import as from './as.js';
import Hidden from './Hidden.js';
import { c as HiddenToggle, b as HiddenShow, a as HiddenHide } from './chunk-6133b9c9.js';
import { a as StepContainer, b as StepNext, c as StepPrevious } from './chunk-2d251948.js';
import 'styled-components';
import '@emotion/is-prop-valid';
import 'react-dom';
import './chunk-a44fd1b3.js';
import './chunk-a7ce379e.js';
import './chunk-d8771a86.js';
import './Box.js';
import './chunk-ac382c96.js';
import 'constate';

var noop = function noop() {
  return false;
};

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Component, _React$Component);

  function Component(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var _this$props = _this.props,
        register = _this$props.register,
        step = _this$props.step,
        order = _this$props.order;
    register(step, order);
    return _this;
  }

  var _proto = Component.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
        step = _this$props2.step,
        update = _this$props2.update,
        order = _this$props2.order;

    if (prevProps.step !== step || prevProps.order !== order) {
      update(prevProps.step, step, order);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this$props3 = this.props,
        step = _this$props3.step,
        unregister = _this$props3.unregister;
    unregister(step);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        isCurrent = _this$props4.isCurrent,
        step = _this$props4.step;
    return React__default.createElement(Hidden, _extends({
      unmount: true,
      visible: isCurrent(step)
    }, this.props));
  };

  return Component;
}(React__default.Component);

hoistNonReactStatics(Component, Hidden);
var Step = styled(Component).withConfig({
  displayName: "Step",
  componentId: "sc-13njvly-0"
})(["", ";"], theme("Step"));
Step.propTypes = {
  step: PropTypes__default.string.isRequired,
  register: PropTypes__default.func.isRequired,
  update: PropTypes__default.func.isRequired,
  unregister: PropTypes__default.func.isRequired,
  isCurrent: PropTypes__default.func.isRequired,
  order: PropTypes__default.number
};
Step.defaultProps = {
  register: noop,
  update: noop,
  unregister: noop,
  isCurrent: noop
};
var Step$1 = as("div")(Step);

var toggle = function toggle(props) {
  return function () {
    return props.toggle && props.toggle(props.step);
  };
};

var Component$1 = function Component(props) {
  return React__default.createElement(HiddenToggle, _extends({}, props, {
    toggle: toggle(props)
  }));
};

var StepToggle = styled(Component$1).withConfig({
  displayName: "StepToggle",
  componentId: "oour1d-0"
})(["", ";"], theme("StepToggle"));
StepToggle.propTypes = {
  toggle: PropTypes__default.func.isRequired,
  step: PropTypes__default.string.isRequired
};
var StepToggle$1 = as("button")(StepToggle);

var show = function show(props) {
  return function () {
    return props.show && props.show(props.step);
  };
};

var Component$2 = function Component(props) {
  return React__default.createElement(HiddenShow, _extends({}, props, {
    show: show(props)
  }));
};

var StepShow = styled(Component$2).withConfig({
  displayName: "StepShow",
  componentId: "sc-1eog66r-0"
})(["", ";"], theme("StepShow"));
StepShow.propTypes = {
  show: PropTypes__default.func.isRequired,
  step: PropTypes__default.string.isRequired
};
var StepShow$1 = as("button")(StepShow);

var StepHide = styled(HiddenHide).withConfig({
  displayName: "StepHide",
  componentId: "sc-1523whe-0"
})(["", ";"], theme("StepHide"));
var StepHide$1 = as("button")(StepHide);

Step$1.Container = StepContainer;
Step$1.Toggle = StepToggle$1;
Step$1.Show = StepShow$1;
Step$1.Hide = StepHide$1;
Step$1.Next = StepNext;
Step$1.Previous = StepPrevious;

export default Step$1;
